// extracted by mini-css-extract-plugin
export default {"page":"CarsPage_page__NIPS6","header":"CarsPage_header__tW2iM"};